// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2gZH_","title":"AfterBackImages_title__15n0t","images":"AfterBackImages_images__3u3P7"};